import PropTypes from "prop-types";
import React from "react";
import { useFieldArray } from "react-hook-form";
import { WorkScheduleStyled } from "./work-schedule.style";
import { TextInputFormField } from "../text-input-field/text-input-form-field";
import { Typography } from "@mui/material";

const WEEK_DAYS = [
  { id: 1, label: "Monday" },
  { id: 2, label: "Tuesday" },
  { id: 3, label: "Wednesday" },
  { id: 4, label: "Thursday" },
  { id: 5, label: "Friday" },
];

const WorkSchedule = ({ control, name, label }) => {
  const { fields } = useFieldArray({
    control,
    name,
  });

  return (
    <WorkScheduleStyled>
      {label && (
        <div className="label">
          <Typography variant="body1">{label}</Typography>
        </div>
      )}
      <div className="fields">
        {fields.map((field, index) => (
          <div key={field.id} className="width">
            <Typography variant="body3" className="day-label">
              {WEEK_DAYS[index].label}
            </Typography>
            <TextInputFormField
              name={`${name}.${index}.hours`}
              control={control}
              className="input-field"
              placeholder="0"
              variant="outlined"
              inputType="number"
              sx={{
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                    display: "none",
                  },
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
                "& fieldset": { border: "none", padding: "0px !important" },
              }}
            />
          </div>
        ))}
      </div>
    </WorkScheduleStyled>
  );
};

WorkSchedule.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  control: PropTypes.any.isRequired,
};

export default WorkSchedule;
